module.exports = __webpack_public_path__ + "static/media/Portrait-10254.53293816.jpg";